import { DOMEventDispatcher } from 'apps/webcomponents/src/utils/event.utils';
import { LitElement, html } from 'lit';
import { property, state, query } from 'lit/decorators.js';
import { QuarantineEvent } from '../../../exchangeProtection/types';
import { styles } from '../view/styles';
import { SaveSelectedItemEnabler } from '../../../exchangeProtection/helpers/saveSelectedItemEnabler';
import { GzTextareaWebComponent } from 'apps/webcomponents/src/ui/gzInput';
import { GzDialogEvents } from 'apps/webcomponents/src/ui/gzDialog/component/GzDialog';

export class QuarantineSaveFormWebComponent extends LitElement {
  @property({ type: Function })
  public translateFn: Function;

  @state()
  private translations = {
    saveToFolderText: null,
    save: null,
    cancel: null,
  };

  @query('[data-textarea]')
  private textareaElement: GzTextareaWebComponent;

  @state()
  public formData = {
    savePath: '',
    isValid: false,
  };

  static get styles() {
    return styles;
  }

  protected firstUpdated(changedProperties): void {
    super.update(changedProperties);
    this.setupTranslations(this.translateFn);
  }

  private setupTranslations(translateFn): void {
    this.translations = {
      saveToFolderText: translateFn('Save to this folder'),
      save: translateFn('Save#preserve state'),
      cancel: translateFn('cancel'),
    };
  }

  private textAreaValueChange({ detail }): void {
    const value = detail.sourceEvent;

    this.formData = {
      ...this.formData,
      savePath: value,
    };

    this.validate();
  }

  private validate() {
    const formValid = SaveSelectedItemEnabler.handlesSavePath(this.formData.savePath);

    this.formData = {
      ...this.formData,
      isValid: formValid,
    };

    if (!this.formData.isValid) {
      this.textareaElement.markAsInvalid();
    } else {
      this.textareaElement.markAsValid();
    }

    DOMEventDispatcher.dispatchLocalEvent(this, QuarantineEvent.SAVE, formValid);
  }

  private save(): void {
    if (this.formData.isValid) {
      DOMEventDispatcher.dispatchGlobalEvent(this, GzDialogEvents.CONFIRM, this.formData);
    }
  }

  private cancel(): void {
    DOMEventDispatcher.dispatchGlobalEvent(this, GzDialogEvents.CANCEL);
  }

  render() {
    return html`
      <form class="ml-5 mt-5">
        <gz-text fontSize="14">${this.translations.saveToFolderText}</gz-text>
        <gz-textarea
          data-textarea
          inputWidth="480"
          class="pt-2"
          placeholder="Specific folder paths"
          rows=${6}
          @change=${this.textAreaValueChange}
        >
        </gz-textarea>
      </form>

      <div class="footer__container">
        <gz-button data-confirm ?disabled=${!this.formData.isValid} @click=${this.save}>
          ${this.translations.save}
        </gz-button>
        <gz-button data-cancel type="outline" color="secondary" @click=${this.cancel}>
          ${this.translations.cancel}
        </gz-button>
      </div>
    `;
  }
}
